import { computed, observable } from 'mobx';
import { useMount } from 'ahooks';
import { autobind } from 'core-decorators';
import { useEffect } from 'react';
import Cookie from '@src/utils/cookie';

import CookieSettingModalStore from '../cookie-setting-modal/store';

export const COOKIE_FLAG = 'cookie_flag';

class CookieTipsStore {
  cookieSettingModalStore = new CookieSettingModalStore();
  /**
   *
   * @type {boolean}
   */
  @observable isDirectToSettingModal = false;

  @observable cookieFlagInfo;
  /**
   * 是否显示modal
   * @type {boolean}
   */
  @observable showModalStatus = false;
  /**
   * 设置
   * @type {boolean}
   */
  @observable showCookieSettings = true;

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  @observable setCookieDescription = '';

  /**
   * 是否允许cookies
   * @type {{analytics: boolean, necessary: boolean}}
   */
  @observable
  acceptCookies = {
    necessary: true,
    analytics: false
  };

  /**
   * 关闭按钮
   * @type {function()}
   */
  @autobind
  onClose() {
    this.showModalStatus = false;
  }

  @autobind
  changeShowModalStatus(status) {
    this.showModalStatus = status;
  }

  @autobind
  onCookieSettingShowClick() {
    this.cookieSettingModalStore.isShow = true;
    this.showCookieSettings = false;
    this.getCookieFlag();
    this.init();
  }

  @autobind
  backToCookieTipModal() {
    this.cookieSettingModalStore.isShow = false;
    this.showCookieSettings = true;
  }

  /**
   * 是否存在CookieFlag
   * @returns {boolean}
   */
  @computed
  get hasCookieFlag() {
    return !!this.cookieFlagInfo;
  }

  /**
   * 标记cookie是否已经选择
   */
  @autobind
  setCookieFlag(status = { necessary: 1, analytics: 0 }) {
    Cookie.set(COOKIE_FLAG, status, { expires: 90 });
    // Cookie.set(COOKIE_FLAG, status, { expires: new Date(new Date().getTime() + 5 * 60 * 1000) });
    this.acceptCookies.analytics = status.analytics;
    this.acceptCookies.necessary = status.necessary;
  }

  @autobind
  getCookieFlag() {
    this.cookieFlagInfo = Cookie.get(COOKIE_FLAG);
  }

  /**
   * 点击"拒绝可选cookie"按钮时回调
   */
  @autobind
  rejectOptionalCookies() {
    this.setCookieFlag({ necessary: 1, analytics: 0 });
    this.changeShowModalStatus(false);
  }

  /**
   * 点击"接受所有的cookie"按钮时回调
   */
  @autobind
  acceptOptionalCookies() {
    this.setCookieFlag({ necessary: 1, analytics: 1 });
    this.changeShowModalStatus(false);
  }

  /**
   * 初始化
   */
  @autobind
  init() {
    if (this.hasCookieFlag) {
      const info = JSON.parse(this.cookieFlagInfo);
      this.acceptCookies.necessary = info.necessary;
      this.acceptCookies.analytics = info.analytics;
      this.cookieSettingModalStore.acceptCookies.analytics = info.analytics;
      this.cookieSettingModalStore.acceptCookies.necessary = info.necessary;
    } else {
      this.acceptCookies.necessary = 1;
      this.acceptCookies.analytics = 0;
      this.cookieSettingModalStore.acceptCookies.analytics = 0;
      this.cookieSettingModalStore.acceptCookies.necessary = 1;
    }
  }

  use() {
    useMount(() => {
      this.showCookieSettings = true;
      this.getCookieFlag();
      this.cookieSettingModalStore.acceptOptionalCookies = this.acceptOptionalCookies;
      this.cookieSettingModalStore.rejectOptionalCookies = this.rejectOptionalCookies;
      this.init();
    });

    useEffect(
      () => {
        if (!this.hasCookieFlag) {
          this.changeShowModalStatus(true);
        }
      },
      [this.hasCookieFlag]
    );
    useEffect(
      () => {
        this.getCookieFlag();
        this.init();
      },
      [this.isDirectToSettingModal]
    );
    useEffect(
      () => {
        this.cookieSettingModalStore.acceptCookies.analytics = this.acceptCookies.analytics;
        this.cookieSettingModalStore.acceptCookies.necessary = this.acceptCookies.necessary;
      },
      [this.acceptCookies.analytics, this.acceptCookies.necessary]
    );
  }
}

export default CookieTipsStore;
